import * as React from "react";

type PublicPasswordContextType = {
    contentItemResolveKey: string | null;
    contentItemAccessKey: string | null;
    setContentItemResolveKey: React.Dispatch<React.SetStateAction<string | null>>;
    setContentItemAccessKey: React.Dispatch<React.SetStateAction<string | null>>;
};

const PublicContentItemAccessKeyContext = React.createContext<PublicPasswordContextType>({
    contentItemResolveKey: "",
    contentItemAccessKey: "",
    setContentItemResolveKey: () => {},
    setContentItemAccessKey: () => {}
});

const PublicContentItemAccessKey: React.FunctionComponent<React.PropsWithChildren<{ initialResolveKey?: string }>> = ({
    children,
    initialResolveKey = ""
}) => {
    const [contentItemResolveKey, setContentItemResolveKey] = React.useState<string | null>(initialResolveKey);
    const [contentItemAccessKey, setContentItemAccessKey] = React.useState<string | null>("");
    return (
        <PublicContentItemAccessKeyContext.Provider
            value={{ contentItemResolveKey, setContentItemResolveKey, contentItemAccessKey, setContentItemAccessKey }}
        >
            {children}
        </PublicContentItemAccessKeyContext.Provider>
    );
};

function usePublicContentItemAccessKeyContext() {
    const context = React.useContext(PublicContentItemAccessKeyContext);
    return context;
}

export { PublicContentItemAccessKey, usePublicContentItemAccessKeyContext };
